var charts = {};
function chartInitiate() {
	var progressID = 'si-progress-meter';
	var $progressMeter = $('#si-progress-meter');
	if (globalVar.progressType === 'line') {
		$('#si-progress').addClass('line');

		var bar = new ProgressBar.Line('#' + progressID, {
			strokeWidth: 8,
			easing: 'easeInOut',
			duration: 1400,
			trailWidth: 6,
			svgStyle: null,
			text: {
				style: {
					transform: null
				},
				autoStyleContainer: false
			},
			step: function (state, bar) {
				return bar.setText(Math.round(bar.value() * 100) + '% ' + $progressMeter.data('name'));
			}
		});
	} else {
		var bar = new ProgressBar.Circle('#' + progressID, {
			strokeWidth: 8,
			easing: 'easeInOut',
			duration: 1400,
			trailWidth: 6,
			svgStyle: null,
			text: {
				style: {
					transform: null
				},
				autoStyleContainer: false
			},
			step: function (state, bar) {
				return bar.setText(Math.round(bar.value() * 100) + '% ' + $progressMeter.data('name'));
			}
		});
	}
	charts[progressID] = bar;
}

////////*Feature:Progress Meter///////////////////////////////////////////////////////////////////////////////////////////////////////////////

function chartProgress() {
	var slideCompletion = saveData.slideCompletion;
	var pathSelected = saveData.pathSelected;
	var pathsCounted = [];
	var increments = 0;
	var answersCorrect = 0;

	for (var key in slideCompletion) {
		for (var slide in slideCompletion[key]) {
			var alreadyCounted = pathsCounted.indexOf(slide) >= 0;
			var shouldBeCounted = key === 'mainPath' || !pathSelected || key === pathSelected;
			if (!alreadyCounted && shouldBeCounted) {
				increments++;
				pathsCounted.push(slide);
				if (slideCompletion[key][slide]) answersCorrect++;
			}
		}
	}

	getPgr(answersCorrect / increments);
}

function getPgr(percentage) {
	var progressID = 'si-progress-meter';
	var $progressMeter = $('#si-progress-meter');

	charts[progressID].animate(percentage);

	//not updating when increments shift
	$progressMeter.attr('data-percent', percentage);
}
